import { Item, ItemProps, TEST_IDENTIFIER } from 'components/Blocks/Product/CategoryPromotedProducts/Item/Item';
import { ProductLink } from 'components/Blocks/Product/CategoryPromotedProducts/Item/ProductLink';
import { twJoin } from 'tailwind-merge';

export const WebItem: FC<ItemProps> = ({ item, gtmListName, listIndex }) => {
    return (
        <Item item={item}>
            <div className="mr-4 flex flex-1 items-center text-center text-small font-bold">
                <div className={twJoin('pr-7 text-left')} data-testid={TEST_IDENTIFIER + 'name'}>
                    <ProductLink item={item} gtmListName={gtmListName} listIndex={listIndex} />
                </div>
            </div>
        </Item>
    );
};
